import { render, staticRenderFns } from "./PollsList.vue?vue&type=template&id=faa0d46a&scoped=true&"
import script from "./PollsList.vue?vue&type=script&lang=js&"
export * from "./PollsList.vue?vue&type=script&lang=js&"
import style0 from "./PollsList.vue?vue&type=style&index=0&id=faa0d46a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa0d46a",
  null
  
)

export default component.exports